(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2465],{

/***/ 35610:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace",
      function () {
        return __webpack_require__(21841);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stage_image_background; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/default_header.jpg
/* harmony default export */ var default_header = ({"src":"/_next/static/media/default_header.e80958d5.jpg","height":775,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBAURE9H/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAAMAAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AhbbNutDM60kgqOehPIiJSoE6f//Z"});
// EXTERNAL MODULE: ./src/utils/_hooks/useWindowSize.hook.ts
var useWindowSize_hook = __webpack_require__(29486);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.module.scss
var stage_image_background_module = __webpack_require__(48106);
var stage_image_background_module_default = /*#__PURE__*/__webpack_require__.n(stage_image_background_module);
;// CONCATENATED MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StageImageBackground = function(props) {
    var ref = _slicedToArray((0,useWindowSize_hook/* default */.Z)(), 1), width = ref[0];
    var _url;
    return width ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "".concat((stage_image_background_module_default())["stage-background"], " ").concat(props.className ? props.className : ""),
        src: (_url = props.url) !== null && _url !== void 0 ? _url : default_header.src,
        alt: props.alt,
        layout: "fill",
        sizes: width > 1920 ? "100vw" : "1920px",
        objectPosition: props.objectPosition,
        objectFit: "cover",
        priority: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
/* harmony default export */ var stage_image_background = (StageImageBackground);
StageImageBackground.defaultProps = {
    objectPosition: "top"
};


/***/ }),

/***/ 58523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ StageImageButtonToken; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13692);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92212);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43067);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27397);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var StageImageButtonToken = function(_param) {
    var image = _param.image, editButtonProps = _param.editButtonProps, shadow = _param.shadow, props = _objectWithoutProperties(_param, [
        "image",
        "editButtonProps",
        "shadow"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), src = ref[0], setSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSrc("".concat(image, "?resolution=thumbnail"));
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token"]),
        children: [
            (props === null || props === void 0 ? void 0 : props.hasLink) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__/* .LinkBase */ .w, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token-link"]),
                href: props.href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                    variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                    className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                    icon: {
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: src,
                            onError: function() {
                                return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                            }
                        }),
                        align: "left"
                    },
                    buttonUrl: ""
                }))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                icon: {
                    element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: src,
                        onError: function() {
                            return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                        }
                    }),
                    align: "left"
                },
                buttonUrl: ""
            })),
            editButtonProps && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, editButtonProps, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default().editButton)
            }))
        ]
    });
};



/***/ }),

/***/ 70818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Stage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _assets_icons_creatoken_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43301);
/* harmony import */ var _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76221);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(962);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93217);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27397);
/* harmony import */ var _stage_image_background_stage_image_background__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93659);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28773);
/* harmony import */ var _stage_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26160);
/* harmony import */ var _stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_stage_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _stage_image_button_token_stage_image_button_token__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58523);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var Stage = function(param) {
    var title = param.title, titleVariant = param.titleVariant, verticalOrientation = param.verticalOrientation, titleElement = param.titleElement, description = param.description, orientation = param.orientation, inverted = param.inverted, buttons = param.buttons, background = param.background, logo = param.logo, decButton = param.decButton, textDirection = param.textDirection, size = param.size, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref3, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "stage",
        className: "".concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().stage), " ").concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[size], " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stage_image_background_stage_image_background__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                url: background
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[orientation], " ").concat(inverted ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inverted) : "", " ").concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())["vert-".concat(verticalOrientation === null || verticalOrientation === void 0 ? void 0 : verticalOrientation.toLowerCase())]),
                        children: [
                            logo,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["horizontal-text-alignment"]) : "",
                                children: [
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                                            className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["horizontal-text"]) : "",
                                            variant: titleVariant ? (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapStrapiHeadline */ .z)(titleVariant) : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING1 */ .H.HEADING1,
                                            element: titleElement ? titleElement : "h1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["flex-container"]) : ""
                                    }),
                                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().description),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                                            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.INTROTEXT */ .H.INTROTEXT,
                                            children: description
                                        })
                                    })
                                ]
                            }),
                            buttons && buttons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().buttons),
                                children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function(props) {
                                    var ref, ref2;
                                    if ((props === null || props === void 0 ? void 0 : props.buttonUrl) && (props === null || props === void 0 ? void 0 : props.external)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__/* .LinkBase */ .w, {
                                        href: (ref = props === null || props === void 0 ? void 0 : props.buttonUrl) !== null && ref !== void 0 ? ref : "",
                                        external: props === null || props === void 0 ? void 0 : props.external,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                            inverted: inverted
                                        }, props))
                                    }, props.children);
                                    else if (props === null || props === void 0 ? void 0 : props.buttonUrl) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: (ref2 = props === null || props === void 0 ? void 0 : props.buttonUrl) !== null && ref2 !== void 0 ? ref2 : "",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                                inverted: inverted
                                            }, props))
                                        })
                                    }, props.children);
                                    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                        inverted: inverted
                                    }, props));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: ((ref3 = decButton) === null || ref3 === void 0 ? void 0 : ref3.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().decButtonCustomContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stage_image_button_token_stage_image_button_token__WEBPACK_IMPORTED_MODULE_11__/* .StageImageButtonToken */ .k, _objectSpread({}, decButton, {
                                shadow: true
                            }))
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().decButtonContainer),
                            children: decButton === null || decButton === void 0 ? void 0 : (ref1 = decButton.icon) === null || ref1 === void 0 ? void 0 : ref1.element
                        })
                    })
                ]
            })
        ]
    });
};
Stage.defaultProps = {
    orientation: "CENTER",
    inverted: false,
    size: "Large",
    decButton: {
        icon: {
            element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_creatoken_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            align: "right"
        }
    },
    verticalOrientation: "CENTER"
};


/***/ }),

/***/ 21841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_marketplace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useLoginPage.hook.ts
var useLoginPage_hook = __webpack_require__(92534);
// EXTERNAL MODULE: ./src/api/hooks/useLanguageDependentDataSsr.hook.ts
var useLanguageDependentDataSsr_hook = __webpack_require__(18060);
;// CONCATENATED MODULE: ./src/api/hooks/useMarketplace.hook.ts

var useMarketplacePage = (0,useLanguageDependentDataSsr_hook/* useLanguageDependentDataSSr */.Y)("marketplace-page");

// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./src/components/_shared/stage/stage.tsx
var stage = __webpack_require__(70818);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/api/hooks/useCategories.hook.ts
var useCategories_hook = __webpack_require__(28955);
// EXTERNAL MODULE: ./src/api/hooks/useLookupTableData.hook.ts
var useLookupTableData_hook = __webpack_require__(12310);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/filter-expression.enum.tsx
var filter_expression_enum = __webpack_require__(55190);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/marketplace/main-filter-form/main-filter-form.module.scss
var main_filter_form_module = __webpack_require__(52276);
var main_filter_form_module_default = /*#__PURE__*/__webpack_require__.n(main_filter_form_module);
;// CONCATENATED MODULE: ./src/components/marketplace/main-filter-form/main-filter-form.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var MainFilterForm = function(props) {
    var ref2;
    var dispatch = (0,es/* useDispatch */.I0)();
    var categories = (0,useCategories_hook/* useCategories */.L)();
    var data = useMarketplacePage();
    var originators = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice.originators;
    });
    var filter = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice.detailedInstances.filter;
    });
    var ref1 = (0,index_esm/* useForm */.cI)({
        mode: "onTouched"
    }), control = ref1.control, getValues = ref1.getValues, setValue = ref1.setValue, reset = ref1.reset, handleSubmit = ref1.handleSubmit;
    (0,react.useEffect)(function() {
        dispatch((0,redux/* fetchAllOriginators */.kW)());
        if (props.openInDialog && filter) {
            var categoryId = filter.find(function(item) {
                return item.param === "categoryId";
            });
            var originatorsIds = filter.find(function(item) {
                return item.param === "originatorId";
            });
            if (categoryId) {
                setValue("categoryId", categoryId.value);
            }
            if (originatorsIds) {
                setValue("originatorsIds", originatorsIds.value);
            }
        }
    }, []);
    var resetFilter = function() {
        if (filter) {
            var currentFilters = _toConsumableArray(filter.filter(function(item) {
                return item.param === "status" || item.param === "sort" || item.param === "owner";
            }));
            reset();
            dispatch((0,redux/* setFilter */.Tv)(currentFilters));
        }
    };
    var changeFilter = function(triggeredByForm) {
        if (filter) {
            var currentFilters = _toConsumableArray(filter.filter(function(item) {
                return item.param === "sortBy" || item.param === "status" || item.param === "size" || item.param === "sort" || item.param === "owner" || item.param === "page";
            }));
            if (getValues("originatorsIds") && getValues("originatorsIds").length > 0) {
                currentFilters.push({
                    value: getValues("originatorsIds") ? getValues("originatorsIds").toString() : " ",
                    param: "originatorId",
                    comparisonType: filter_expression_enum/* FilterExpression.in */.p["in"]
                });
            }
            if (getValues("categoryId")) {
                var ref;
                currentFilters.push({
                    value: (ref = getValues("categoryId")) !== null && ref !== void 0 ? ref : "",
                    param: "categoryId",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                });
            }
            if (!props.openInDialog || triggeredByForm) {
                dispatch((0,redux/* setFilter */.Tv)(currentFilters));
                if (props.onCloseModal) {
                    props.onCloseModal();
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (main_filter_form_module_default())["main-filter-form"],
        onSubmit: handleSubmit(function() {
            return changeFilter(true);
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                className: (main_filter_form_module_default())["filter-headline"],
                children: [
                    data.filterHeadline.headlineContent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        onClick: resetFilter,
                        className: (main_filter_form_module_default())["reset-filter"],
                        icon: {
                            element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: [
                                    "fas",
                                    "undo"
                                ]
                            }),
                            align: "right"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                control: control,
                label: data.productType.fieldLabel,
                placeholder: data.productType.fieldHint,
                isClearable: true,
                onChange: function() {
                    return changeFilter();
                },
                name: "categoryId",
                options: (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)((ref2 = categories.data) === null || ref2 === void 0 ? void 0 : ref2.data).map(function(cat) {
                    return {
                        value: cat.id,
                        label: cat.text
                    };
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                control: control,
                label: data.originator.fieldLabel,
                placeholder: data.originator.fieldHint,
                isMulti: true,
                onChange: function() {
                    return changeFilter();
                },
                name: "originatorsIds",
                options: originators.map(function(org) {
                    return {
                        value: org.id,
                        label: "".concat(org.firstName, " ").concat(org.lastName)
                    };
                })
            }),
            props.openInDialog ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                children: data.applyFilter.buttonText
            }) : null
        ]
    });
};
/* harmony default export */ var main_filter_form = (MainFilterForm);

// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
// EXTERNAL MODULE: ./src/components/marketplace/marketplace-instance-teaser/marketplace-instance-teaser.module.scss
var marketplace_instance_teaser_module = __webpack_require__(44630);
var marketplace_instance_teaser_module_default = /*#__PURE__*/__webpack_require__.n(marketplace_instance_teaser_module);
;// CONCATENATED MODULE: ./src/components/marketplace/marketplace-instance-teaser/marketplace-instance-teaser.tsx
function marketplace_instance_teaser_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function marketplace_instance_teaser_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return marketplace_instance_teaser_arrayLikeToArray(arr);
}
function marketplace_instance_teaser_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function marketplace_instance_teaser_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function marketplace_instance_teaser_toConsumableArray(arr) {
    return marketplace_instance_teaser_arrayWithoutHoles(arr) || marketplace_instance_teaser_iterableToArray(arr) || marketplace_instance_teaser_unsupportedIterableToArray(arr) || marketplace_instance_teaser_nonIterableSpread();
}
function marketplace_instance_teaser_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return marketplace_instance_teaser_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return marketplace_instance_teaser_arrayLikeToArray(o, minLen);
}













var MarketplaceInstanceTeaser = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data1 = useMarketplacePage();
    var ref = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instances: state.productSlice.detailedInstances,
            filter: state.productSlice.detailedInstances.filter
        };
    }), instances = ref.instances, filter = ref.filter;
    (0,react.useEffect)(function() {
        fetchInstancesWithFilter(0, 24);
    }, [
        filter
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,redux/* setFilter */.Tv)(marketplace_instance_teaser_toConsumableArray(instances.filter.filter(function(item) {
                return item.param !== "owner" && item.param !== "isResale";
            }))));
        };
    }, []);
    var fetchInstancesWithFilter = function(offset, pageSize) {
        var currentInstanceFilter = [
            {
                value: pageSize.toString(),
                param: "size",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: offset.toString(),
                param: "page",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: "OPEN",
                param: "status",
                comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
            }
        ].concat(marketplace_instance_teaser_toConsumableArray(filter));
        dispatch((0,redux/* fetchDetailedInstances */.dA)(currentInstanceFilter));
    };
    if ((instances === null || instances === void 0 ? void 0 : instances.data) && instances.data.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (marketplace_instance_teaser_module_default())["marketplace-instances-wrapper"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                headline: "",
                hideTeaserButtons: true,
                maxCards: instances.maxNumber,
                headlineElement: "h2",
                headlineVariant: typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1,
                withNumbers: true,
                pending: instances.pending,
                pagination: instances.pagination,
                cards: instances.data.map(function(instance) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                        instance: instance
                    }, "marketplace-instance-".concat(instance.id));
                }),
                onLoadNewItems: function(data) {
                    fetchInstancesWithFilter(data.pageOrOffset, data.size);
                },
                type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
            className: (marketplace_instance_teaser_module_default())["no-instances-message"],
            children: data1.noItemsWithFilter
        });
    }
};
/* harmony default export */ var marketplace_instance_teaser = (MarketplaceInstanceTeaser);

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__(92565);
// EXTERNAL MODULE: ./src/components/_shared/dialog/dialog.tsx + 2 modules
var dialog = __webpack_require__(72807);
// EXTERNAL MODULE: ./src/components/marketplace/marketplace-modal-filter/marketplace-modal-filter.module.scss
var marketplace_modal_filter_module = __webpack_require__(46564);
var marketplace_modal_filter_module_default = /*#__PURE__*/__webpack_require__.n(marketplace_modal_filter_module);
;// CONCATENATED MODULE: ./src/components/marketplace/marketplace-modal-filter/marketplace-modal-filter.tsx
function marketplace_modal_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function marketplace_modal_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return marketplace_modal_filter_arrayLikeToArray(arr);
}
function marketplace_modal_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function marketplace_modal_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function marketplace_modal_filter_toConsumableArray(arr) {
    return marketplace_modal_filter_arrayWithoutHoles(arr) || marketplace_modal_filter_iterableToArray(arr) || marketplace_modal_filter_unsupportedIterableToArray(arr) || marketplace_modal_filter_nonIterableSpread();
}
function marketplace_modal_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return marketplace_modal_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return marketplace_modal_filter_arrayLikeToArray(o, minLen);
}











var MarketplaceModalFilter = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), showDialog = ref[0], setShowDialog = ref[1];
    var filter = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice.detailedInstances.filter;
    });
    var resetFilter = function() {
        if (filter) {
            var currentFilters = marketplace_modal_filter_toConsumableArray(filter.filter(function(item) {
                return item.param === "status" || item.param === "sort" || item.param === "ownerId";
            }));
            dispatch((0,redux/* setFilter */.Tv)(currentFilters));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (marketplace_modal_filter_module_default())["marketplace-filter-modal"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                onClick: resetFilter,
                className: (marketplace_modal_filter_module_default())["filter-mobile-buttons"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: pro_solid_svg_icons_index_es/* faUndo */.X7o
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                className: (marketplace_modal_filter_module_default())["filter-mobile-buttons"],
                onClick: function() {
                    return setShowDialog(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons_index_es/* faFilter */.G_j
                })
            }),
            showDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* default */.Z, {
                onClose: function() {
                    return setShowDialog(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_filter_form, {
                    openInDialog: true,
                    onCloseModal: function() {
                        return setShowDialog(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var marketplace_modal_filter = (MarketplaceModalFilter);

// EXTERNAL MODULE: ./src/utils/_enums/sorting-options.enum.tsx
var sorting_options_enum = __webpack_require__(77923);
// EXTERNAL MODULE: ./src/components/_shared/toggle-bar/toggle-bar.module.scss
var toggle_bar_module = __webpack_require__(97446);
var toggle_bar_module_default = /*#__PURE__*/__webpack_require__.n(toggle_bar_module);
;// CONCATENATED MODULE: ./src/components/_shared/toggle-bar/toggle-bar.tsx





var ToggleBar = function(props) {
    var ref = (0,react.useState)(true), leftActive = ref[0], setLeftActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (toggle_bar_module_default())["toggle-bar"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: leftActive ? (toggle_bar_module_default())["toggle-bar-left-wrapper-active"] : (toggle_bar_module_default())["toggle-bar-left-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: leftActive ? (toggle_bar_module_default())["toggle-bar-left-active"] : (toggle_bar_module_default())["toggle-bar-left"],
                    onClick: function() {
                        if (!leftActive) {
                            setLeftActive(true);
                            props.onToggleLeft();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: leftActive ? typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5 : typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                        children: props.leftHeadline
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: leftActive ? (toggle_bar_module_default())["toggle-bar-right-wrapper"] : (toggle_bar_module_default())["toggle-bar-right-wrapper-active"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: leftActive ? (toggle_bar_module_default())["toggle-bar-right"] : (toggle_bar_module_default())["toggle-bar-right-active"],
                    onClick: function() {
                        if (leftActive) {
                            setLeftActive(false);
                            props.onToggleRight();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: !leftActive ? typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5 : typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                        children: props.rightHeadline
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (toggle_bar_module_default())["empty-line"]
            })
        ]
    });
};
/* harmony default export */ var toggle_bar = (ToggleBar);

// EXTERNAL MODULE: ./src/components/marketplace/upper-filter/upper-filter.module.scss
var upper_filter_module = __webpack_require__(22218);
var upper_filter_module_default = /*#__PURE__*/__webpack_require__.n(upper_filter_module);
;// CONCATENATED MODULE: ./src/components/marketplace/upper-filter/upper-filter.tsx
function upper_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function upper_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return upper_filter_arrayLikeToArray(arr);
}
function upper_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function upper_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function upper_filter_toConsumableArray(arr) {
    return upper_filter_arrayWithoutHoles(arr) || upper_filter_iterableToArray(arr) || upper_filter_unsupportedIterableToArray(arr) || upper_filter_nonIterableSpread();
}
function upper_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return upper_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return upper_filter_arrayLikeToArray(o, minLen);
}












var UpperFilter = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data = useMarketplacePage();
    var instances = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instances: state.productSlice.detailedInstances
        };
    }).instances;
    var control = (0,index_esm/* useForm */.cI)({
        mode: "onTouched"
    }).control;
    var changeFilter = function(isOwnerIdSet) {
        if (instances.filter) {
            var ownerIdFilter = isOwnerIdSet ? [
                {
                    value: "true",
                    param: "owner",
                    comparisonType: filter_expression_enum/* FilterExpression.specified */.p.specified
                }
            ] : [
                {
                    value: "false",
                    param: "owner",
                    comparisonType: filter_expression_enum/* FilterExpression.specified */.p.specified
                }, 
            ];
            dispatch((0,redux/* setFilter */.Tv)(upper_filter_toConsumableArray(instances.filter.filter(function(item) {
                return item.param !== "owner" && item.param !== "isResale";
            })).concat(upper_filter_toConsumableArray(ownerIdFilter))));
        }
    };
    var changeSorting = function(value) {
        if (instances.filter) {
            var currFilter = instances.filter.filter(function(item) {
                return item.param !== "sort";
            });
            switch(value){
                case sorting_options_enum/* SortingOptionsEnum.PRICE_ASC */.R.PRICE_ASC:
                    currFilter.push({
                        value: "price,asc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    currFilter.push({
                        value: "variant.title,asc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    break;
                case sorting_options_enum/* SortingOptionsEnum.PRICE_DESC */.R.PRICE_DESC:
                    currFilter.push({
                        value: "price,desc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    currFilter.push({
                        value: "variant.title,asc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    break;
                case sorting_options_enum/* SortingOptionsEnum.TITLE_ASC */.R.TITLE_ASC:
                    currFilter.push({
                        value: "variant.title,asc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    break;
                case sorting_options_enum/* SortingOptionsEnum.TITLE_DESC */.R.TITLE_DESC:
                    currFilter.push({
                        value: "variant.title,desc",
                        param: "sort",
                        comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                    });
                    break;
            }
            dispatch((0,redux/* setFilter */.Tv)(currFilter));
        }
    };
    if (data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (upper_filter_module_default())["upper-filter"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (upper_filter_module_default())["sort-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                        control: control,
                        label: data.sortBy.fieldLabel,
                        placeholder: data.sortBy.fieldHint,
                        onChange: function(value) {
                            return changeSorting(value.value);
                        },
                        name: "categoryId",
                        options: [
                            {
                                value: sorting_options_enum/* SortingOptionsEnum.TITLE_ASC */.R.TITLE_ASC,
                                label: data.sortByAlphabetAsc
                            },
                            {
                                value: sorting_options_enum/* SortingOptionsEnum.TITLE_DESC */.R.TITLE_DESC,
                                label: data.sortByAlphabetDesc
                            },
                            {
                                value: sorting_options_enum/* SortingOptionsEnum.PRICE_ASC */.R.PRICE_ASC,
                                label: data.sortByLowestPrice
                            },
                            {
                                value: sorting_options_enum/* SortingOptionsEnum.PRICE_DESC */.R.PRICE_DESC,
                                label: data.sortByHighestPrice
                            }, 
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_bar, {
                        onToggleLeft: function() {
                            return changeFilter(false);
                        },
                        onToggleRight: function() {
                            return changeFilter(true);
                        },
                        leftHeadline: data.initialSale,
                        rightHeadline: data.resale
                    })
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var upper_filter = (UpperFilter);

// EXTERNAL MODULE: ./src/views/marketplace/marketplace.module.scss
var marketplace_module = __webpack_require__(12700);
var marketplace_module_default = /*#__PURE__*/__webpack_require__.n(marketplace_module);
;// CONCATENATED MODULE: ./src/views/marketplace/marketplace.tsx
function marketplace_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function marketplace_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return marketplace_arrayLikeToArray(arr);
}
function marketplace_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function marketplace_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function marketplace_toConsumableArray(arr) {
    return marketplace_arrayWithoutHoles(arr) || marketplace_iterableToArray(arr) || marketplace_unsupportedIterableToArray(arr) || marketplace_nonIterableSpread();
}
function marketplace_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return marketplace_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return marketplace_arrayLikeToArray(o, minLen);
}













var Marketplace = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var data = useMarketplacePage();
    if (!data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
            availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
        }),
        stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(stage/* Stage */.H, {
            size: "Small",
            orientation: "LEFT",
            description: "",
            inverted: true,
            titleVariant: (ref = data.stage) === null || ref === void 0 ? void 0 : (ref1 = ref.headline) === null || ref1 === void 0 ? void 0 : ref1.style,
            title: (ref6 = data === null || data === void 0 ? void 0 : (ref2 = data.stage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.headline) === null || ref3 === void 0 ? void 0 : ref3.headlineContent) !== null && ref6 !== void 0 ? ref6 : "",
            background: data === null || data === void 0 ? void 0 : (ref4 = data.stage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.url
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                tags: data === null || data === void 0 ? void 0 : data.meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (marketplace_module_default())["marketplace-content"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (marketplace_module_default())["marketplace-content-left"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_modal_filter, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (marketplace_module_default())["marketplace-content-left-desktop"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main_filter_form, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (marketplace_module_default())["marketplace-content-right"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(upper_filter, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_instance_teaser, {})
                        ]
                    })
                ]
            })
        ]
    });
};
Marketplace.dataHooks = [
    useLoginPage_hook/* useLoginPage */.Y,
    useMarketplacePage
].concat(marketplace_toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));
/* harmony default export */ var marketplace = (Marketplace);

;// CONCATENATED MODULE: ./src/pages/marketplace.tsx

var __N_SSP = true;
/* harmony default export */ var pages_marketplace = (marketplace);


/***/ }),

/***/ 48106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-background":"stage-image-background_stage-background__OC_4p"};

/***/ }),

/***/ 43067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-image-button-token":"stage-image-button-token_stage-image-button-token__NZS_U","stage-image-button-token-link":"stage-image-button-token_stage-image-button-token-link__aBRfn","editButton":"stage-image-button-token_editButton__E4dxD"};

/***/ }),

/***/ 26160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","stage":"stage_stage__mWJSx","Large":"stage_Large__r40ds","Small":"stage_Small__ub55K","Left":"stage_Left__xOlFD","Right":"stage_Right__LnWA4","Center":"stage_Center__pBVue","vert-center":"stage_vert-center__1JjnW","vert-top":"stage_vert-top__HZCap","vert-bottom":"stage_vert-bottom__Narno","inverted":"stage_inverted__5pFbD","LEFT":"stage_LEFT__PidKd","CENTER":"stage_CENTER__IWvi4","RIGHT":"stage_RIGHT__h_mm5","decButtonContainer":"stage_decButtonContainer__4JP7K","decButtonCustomContainer":"stage_decButtonCustomContainer__dnItl","title":"stage_title__gG1nb","description":"stage_description__ZlSUN","horizontal-text-alignment":"stage_horizontal-text-alignment__9P2HF","horizontal-text":"stage_horizontal-text__KtwRO","flex-container":"stage_flex-container__MEEZy","buttons":"stage_buttons__L6Krm"};

/***/ }),

/***/ 97446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","toggle-bar":"toggle-bar_toggle-bar__bwSTu","empty-line":"toggle-bar_empty-line__4Cifi","toggle-bar-left-wrapper-active":"toggle-bar_toggle-bar-left-wrapper-active__VZFoX","toggle-bar-right-wrapper-active":"toggle-bar_toggle-bar-right-wrapper-active__QZ3f5","toggle-bar-left-active":"toggle-bar_toggle-bar-left-active__ObB95","toggle-bar-right-active":"toggle-bar_toggle-bar-right-active__3bAhM","toggle-bar-right-wrapper":"toggle-bar_toggle-bar-right-wrapper__AeIJu","toggle-bar-left-wrapper":"toggle-bar_toggle-bar-left-wrapper__KKD4K"};

/***/ }),

/***/ 52276:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","main-filter-form":"main-filter-form_main-filter-form__67ldl","filter-headline":"main-filter-form_filter-headline___tOEt","reset-filter":"main-filter-form_reset-filter__ICSrz"};

/***/ }),

/***/ 44630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"no-instances-message":"marketplace-instance-teaser_no-instances-message__RIAMv","marketplace-instances-wrapper":"marketplace-instance-teaser_marketplace-instances-wrapper__p0icL"};

/***/ }),

/***/ 46564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","marketplace-filter-modal":"marketplace-modal-filter_marketplace-filter-modal__pu5SF"};

/***/ }),

/***/ 22218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","sort-wrapper":"upper-filter_sort-wrapper__h7pC2"};

/***/ }),

/***/ 12700:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","marketplace-content":"marketplace_marketplace-content__yHKKc","marketplace-content-left":"marketplace_marketplace-content-left__bJbev","marketplace-content-right":"marketplace_marketplace-content-right__kR76z","marketplace-content-left-desktop":"marketplace_marketplace-content-left-desktop__PQTrK"};

/***/ }),

/***/ 86037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
}(this, (function (exports, React) {
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return n;
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
        if (absX < delta && absY < delta && !state.swiping) return state;
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        };
        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
        props.onSwiping && props.onSwiping(eventData);
        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped" + eventData.dir];
          onSwipedDir && onSwipedDir(eventData);
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };

    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        });

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      if (el === null) return;
      set(function (state, props) {
        if (state.el === el) return state;
        var addState = {};

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = void 0;
        }

        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        }

        return _extends({}, state, {
          el: el
        }, addState);
      });
    };

    var output = {
      ref: onRef
    };

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {};

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = void 0;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React__namespace.useRef(_extends({}, initialState));
    var transientProps = React__namespace.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options, {
      delta: options.delta === void 0 ? defaultProps.delta : options.delta,
      rotationAngle: options.rotationAngle === void 0 ? defaultProps.rotationAngle : options.rotationAngle,
      trackTouch: options.trackTouch === void 0 ? defaultProps.trackTouch : options.trackTouch
    });

    var _React$useMemo = React__namespace.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,855,725,2888,179], function() { return __webpack_exec__(35610); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);